import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  loading: false,
  invoices: [],
  count: 0,

  filters: [],
  searchParams: {},
}

const invoices = createSlice({
  name: 'invoices',
  initialState,
  reducers: {
    invoicesRequest(state, payload) {
      state.loading = true
      Object.assign(state.searchParams, payload)
    },
    invoicesSuccess(state, { payload }) {
      state.invoices = payload.invoices
      state.count = payload.count
      state.loading = false
    },
    invoicesFailure(state) {
      state.loading = false
    },
  },
})

export const { invoicesRequest, invoicesSuccess, invoicesFailure } =
  invoices.actions
export default invoices.reducer
